module.exports = __webpack_public_path__ + "10_mole.2e240008.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer2/10_mole.png
// module id = wEaX
// module chunks = 0